var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BaseText"},[(_vm.heading || _vm.preheading)?_c('BaseHeading',{attrs:{"preheading":_vm.preheading,"heading":_vm.heading,"tag":_vm.tag}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wysiwyg",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }